import React from "react";
import Group from "@gqlapp/base/utils/Group";
export default (function Promo({}){
	return <Group>Promo</Group>
})